<template>
  <main class="page gallery-page">
    <div class="gallery-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Галерея</span>
        </li>
      </ul>
      <h1 class="gallery-page__title">Галерея</h1>
      <ul class="gallery-page__items" v-if="$store.state.gallery && $store.state.gallery.data.length">
        <li class="gallery-page__item" v-for="(gallery, index) in $store.state.gallery.data" :key="index">
          <router-link :to="{ name: 'photos', params: {id: gallery.id} }" class="gallery" :title='gallery.name | optimalTitle' :aria-label='gallery.name | optimalTitle'>
            <img class="gallery__image" :src="gallery.img_gallery | findSource($store.state.api)" :alt='gallery.name | optimalTitle' @error="error"/>
            <h3 class="gallery__title">{{ gallery.name | optimalTitle }}</h3>
            <time class="gallery__date" :datetime="gallery.updated_at | robotDate">{{ gallery.updated_at | humanDate }}</time>
          </router-link>
        </li>
      </ul>
      <span class="document-page__empty" v-else>Материалы отсутствуют</span>
      <div class="gallery-page__more" v-if="$store.state.gallery && $store.state.gallery.next_page_url && $store.state.gallery.data.length">
        <button class="button" @click="$store.dispatch('GALLERY_PAGE', true)" type="button">Показать еще</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'GalleryPage',
  async asyncData ({ store, route }) {
    await store.dispatch('GALLERY_PAGE', route.params.id)
  },
  methods: {
    error (e) {
      if (e.target.src !== '/public/img/gallery-placeholder.svg') e.target.src = '/public/img/gallery-placeholder.svg'
    }
  },
  metaInfo () {
    return this.$store.state.department ? this.$seo(
      'common',
      'Галерея',
      'управление образования, образование',
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю',
      'Галерея',
      this.$store.state.api + this.$store.state.department.img_head,
      'Сайт ' + this.$store.state.department.title + '. В сайте есть информация о проектах, учреждениях, актуальные новости и обращение к руководителю'
    ) : this.$seo('common', '', '', '', '', '', '')
  }
}
</script>
